// extracted by mini-css-extract-plugin
export var loadingSpinner = "_44-1";
export var standaloneTable = "_44-0";